module.exports = __webpack_public_path__ + "media/warranty-claim/box-60e1a72d.svg";